import { SimpleGrid } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { QUERY_KEYS, useTeamFavMetrics } from '../../../api';
import {
  AddMetrics,
  MetricsCard,
  MetricTooltip,
  PeriodType,
} from '@devd-client/devd/components';
import { getRole, UserRole } from '@devd-client/api';

interface TeamMetricsProps {
  selected: PeriodType;
}

const TeamMetrics = ({ selected }: TeamMetricsProps) => {
  const { pathname } = useLocation();
  const { data, isLoading } = useTeamFavMetrics(
    decodeURIComponent(pathname.split('/')[2])
  );

  const teamFavMetrics = data?.dto?.map((metric: MetricTooltip) =>
    metric.name === 'CUSTOM' ? metric.title : metric.name
  );

  const isEmployee = getRole() === UserRole.EMPLOYEE;

  return (
    <SimpleGrid columns={{ sm: 1, md: 2 }} spacing={6}>
      {teamFavMetrics?.map((type: string) => (
        <MetricsCard
          key={type}
          metricType={type}
          selected={selected}
          selectedTeam={decodeURIComponent(pathname.split('/')[2])}
          teamMetrics
          queryKey={QUERY_KEYS.teamFavMetrics}
          disableRemove={isEmployee}
        />
      ))}
      {!isEmployee && (
        <AddMetrics
          title="Add Team Metrics"
          modalHeading="Add Team Metrics"
          buttonText="Save"
          queryKeys={QUERY_KEYS}
          name="Teams"
          favouriteMetrics={teamFavMetrics || []}
          forTeam
        />
      )}
    </SimpleGrid>
  );
};

export default TeamMetrics;
